// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

// CSS
import "./styles.scss"

// Components/Containers
import Button from '../../components/Button'
import Form from '../../components/Form'
import Input from '../../components/Input'
import Warning from '../Warning'

// Validate
import * as validate from '../../constants/validate'

// Imgs
import company1Img from '../../assets/company-1.svg'
import company2Img from '../../assets/company-2.svg'
import handshakeImg from '../../assets/handshake.svg'
import lawyer1Img from '../../assets/lawyer-1.svg'
import lawyer2Img from '../../assets/lawyer-2.svg'
import signImg from '../../assets/sign.svg'
import negotiationImg from '../../assets/negotiation.svg'

// Actions
import { profile } from '../ProfilePage/actions'

import withParams from '../../hoc/WithParams'

class SlidePage extends Component {
  handleFormSubmit = (reduxFormData) => {
    const { profile } = this.props

    return profile(reduxFormData)
  }

  render() {
    const { localLoading, err, success, user: { name }, invited, slide, handleSubmit } = this.props
    const { handleSkip } = this.props
    let title
    let text
    let src
    let button
    let nameCapitalized = name

    if (name) {
      nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }

    switch (slide) {
      case '0':
        title = <p><span className="tour-slide__span">Bem vindo Dr(a). {nameCapitalized},</span><br /> Você recebeu um convite para negociar</p>
        text = 'Desejamos uma boa sorte e uma ótima negociação.'
        button = 'Visualizar Meus Casos'
        break;
      case '1':
        title = <p>Você completou o seu cadastro no <br /><span className="tour-slide__span">Com Acordo</span></p>
        text = 'Acompanhe o nosso tour para entender melhor sobre a plataforma.'
        button = 'Iniciar Tour'
        break
      case '2':
        title = <p>Insira um <span className="tour-slide__span">novo caso</span></p>
        text = 'Para começar a usar a plataforma basta completar os campos que irão aparecer, adicionar a inicial em .PDF e, se necessário, adicionar qualquer anexo relevante ao caso.'
        button = 'Continuar'
        src = lawyer1Img
        break
      case '3':
        title = <p>Status <span className="tour-slide__span tour-slide__span--3">em análise</span></p>
        text = 'Em seguida, o caso será submetido à avaliação da empresa, alterando o status na plataforma para “em análise”. A empresa dispõe de 20 dias úteis para informar se tem interesse em negociar.'
        button = 'Continuar'
        src = company1Img
        break
      case '4':
        title = <p>Status <span className="tour-slide__span tour-slide__span--4">em negociação</span></p>
        text = 'Caso haja interesse da empresa, o status passará para “em negociação”. Através do nosso chat, você e a empresa poderão negociar diretamente.'
        button = 'Continuar'
        src = negotiationImg
        break;
      case '5':
        title = <p>Status <span className="tour-slide__span tour-slide__span--5">em finalização</span></p>
        text = 'Uma vez finalizado o acordo com sucesso, o caso entrará "em finalização". Nessa fase, serão trocadas as informações necessárias para a confecção da minuta e aprovada a versão final da mesma para assinatura.'
        button = 'Continuar'
        src = signImg
        break;
      case '6':
        title = <p>Status <span className="tour-slide__span tour-slide__span--6">arquivados</span></p>
        text = 'Este é o último status. Aqui ficarão todos os casos já concluídos com ou sem acordo.'
        button = 'Continuar'
        src = handshakeImg
        break;
      case '7':
        title = <p><span className="tour-slide__span">Parabéns!</span><br />Você concluiu o tour</p>
        text = 'Agora é só entrar na plataforma e inserir o seu primeiro caso.\n Qualquer dúvida é só entrar em contato conosco.'
        button = 'Entrar'
        break;
      default:
    }

    return (
      <div className="tour-slide">
        {(slide === '2' || slide === '3' || slide === '4' || slide === '5' || slide === '6') &&
          <div className="tour-slide__wrapper">
            <div className="tour-slide__timeline">
              <div className={slide === '2' ? 'tour-slide__circle tour-slide__circle--active' : 'tour-slide__circle'}>1</div>
              <div className={slide === '3' ? 'tour-slide__circle tour-slide__circle--active' : 'tour-slide__circle'}>2</div>
              <div className={slide === '4' ? 'tour-slide__circle tour-slide__circle--active' : 'tour-slide__circle'}>3</div>
              <div className={slide === '5' ? 'tour-slide__circle tour-slide__circle--active' : 'tour-slide__circle'}>4</div>
              <div className={slide === '6' ? 'tour-slide__circle tour-slide__circle--active' : 'tour-slide__circle'}>5</div>
              <div className="tour-slide__line" />
            </div>
            <img src={src} alt="" className="tour-slide__img" />
          </div>
        }
        <div className="tour-slide__title">{title}</div>
        <p className="tour-slide__text">{text}</p>
        <div className="tour-slide__buttons">
          {(slide === '0') &&
            <NavLink
              to={`/meus-casos`}
              className="tour-slide__button">
              <Button type={'submit'}>{button}</Button>
            </NavLink>
          }
          {(slide === '1' || slide === '2' || slide === '3' || slide === '4' || slide === '5' || slide === '6') &&
            <NavLink
              to={`/tour/${Number(slide) + 1}`}
              className="tour-slide__button">
              <Button type={(slide === '1' || slide === '7') ? 'submit' : null}>{button}</Button>
            </NavLink>
          }
          {(slide === '1' || slide === '2' || slide === '3' || slide === '4' || slide === '5' || slide === '6') &&
            <NavLink
              to='/inserir-caso-pre-contencioso'
              className="tour-slide__skip">Pular Tour</NavLink>
          }
          {slide === '7' &&
            <NavLink
              to='/inserir-caso-pre-contencioso'
              className="tour-slide__button">
              <Button type={(slide === '1' || slide === '7') ? 'submit' : null}>{button}</Button>
            </NavLink>
          }
        </div>
      </div>
    )
  }
}

const reduxFormValidate = (values) => {
  const errors = {}
  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = 'Senhas não coincidem.'
  }

  if (['semprocesso', 'sem processo', 'comacordo', 'com acordo'].indexOf(values.password) !== -1) {
    errors.password = 'Senha inválida por questões de segurança.'
  }

  return errors
}

SlidePage = reduxForm({
  form: 'slide',
  validate: reduxFormValidate
})(SlidePage)


SlidePage = connect(
  (state, ownProps) => ({
    initialValues: {
      email: state.auth.user.email
    },
    localLoading: state.app.localLoading,
    err: state.app.err,
    success: state.app.success,
    user: state.auth.user,
    invited: state.auth.invited,
    slide: ownProps.params.slide,
  }), { profile })(SlidePage)

export default withParams(SlidePage)
